import { ILogger } from '../concepts/logger';
import { StoreSlice } from '../../utils/store-slice';

export const create: StoreSlice<ILogger> = (set, get) => {
  return {
    log: (msg: string) => {
      console.log(`## ${msg}`);
    },
    error: (reason: string) => {
      console.log(`#! ${reason}`);
    },
  };
};
